import React from 'react'
import PropTypes from 'prop-types'

import { Like, Paper, Leaf } from './Svg'

class Main extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }

  open = ( e ) => {
    e.preventDefault();
    const { elm, openProductWin } = this.props

    openProductWin( elm?.id )
  }

  render() {
    const { elm, favorite, changeFavorite } = this.props

    return (
      <div className='mb-[5px] leading-tight relative overflow-x-hidden'>
        <div className='w-[100%] p-[10px] pl-[0px] bg-white rounded-[25px] flex'>
          {elm?.image != '' &&
            <div className='flex-none relative flex items-center'>
              <img 
                className='w-[150px] h-[auto]' 
                src={elm?.image} 
                alt={elm?.pagetitle} 
                width="149" 
                height="94" 
              />
              {elm?.metka?.name != `` &&
                <div
                  style={{ backgroundColor: elm?.metka?.color }}
                  className='absolute h-[20px] rounded-full px-[10px] top-0 left-[10px] metka-shadow text-white text-[10px] flex items-center'
                >
                  {elm?.metka?.name}
                </div>
              }
            </div>
          }
          <div className='flex-1'>
            <a onClick={( e ) => this.open( e )} href={elm?.href} className='text-black block hover:text-black text-[18px] font-medium mb-[3px] after:absolute after:inset-0 z-0'>
              <span className='relative'>
                {elm?.pagetitle}
                {elm?.metka?.icon == `paper` &&
                  <div className='inline-block ml-[4px]'><Paper /></div>
                }
                {elm?.metka?.icon == `leaf` &&
                  <div className='inline-block ml-[4px]'><Leaf /></div>
                }
              </span>
            </a>

            <div className='text-[14px] text-[#00000099] mb-[8px] line-clamp-2'>{elm?.introtext}</div>
            <div className='flex items-center w-[100%] gap-[5px]'>
              <div className='bg-[#F6F6F6] rounded-full h-[30px] px-[20px] flex items-center justify-center'>
                <div className='text-black text-[16px] font-normal'>от {elm?.price} ₽</div>
              </div>
              <div 
                onClick={() => changeFavorite(elm?.id)} 
                className={`relative z-10 cursor-pointer flex items-center justify-center w-[30px] h-[30px] rounded-full bg-[#F6F6F6] ${
                  favorite.includes(elm?.id) ? 'text-[#F66116]' : 'text-[#C9C9C9]' 
                }`}
              >
                <Like />
              </div>
              <div>
                <div className='text-[#00000099] text-[12px]'>Вес</div>
                <div className='text-black text-[12px]'>{elm?.measure}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Main.propTypes = {
  elm: PropTypes.object,
  favorite: PropTypes.array,
  changeFavorite: PropTypes.func,
  openProductWin: PropTypes.func
}

export default Main